var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},_vm.$listeners),[_c('icon-garbage-bin',{staticClass:"gc-meal__action-icon",attrs:{"size":'md1'}}),(_vm.showText)?_c('text-body-small',{staticClass:"gc-meal__action-text",attrs:{"line-height":'multi'}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }